import React, { FC, useEffect, useState } from 'react';
import { Form, Select, Input, Button, Row, Col } from 'hui';
import { Assessment } from '../../interfaces';
import axios from 'axios';
import { doeApiUrl } from '../../../../api';
import { FormWrapper } from './style';

export const generateFilterUrl = (region: string, aso: string): string => {
  const filters = [];
  let filterUrl = '';
  const regionFilter: string = `filter=region||eq||${region}`;
  const ASOFilter: string = `filter=asoName||cont||${aso}`;
  if (region || aso) {
    filterUrl += '?';
  }
  if (region) {
    filters.push(regionFilter);
  }
  if (aso) {
    filters.push(ASOFilter);
  }
  filterUrl += filters.join('&');
  return filterUrl;
};

interface FilterLayoutProps {
  onFilter(): void;
}

export const generateSelectItems = (data: Assessment[]) => {
  const selectItems = [...new Set(data.map(item => item.region))].map(region => ({
    label: region,
    value: region,
  }));
  selectItems.unshift({
    label: '-',
    value: '',
  });
  return selectItems;
};

export const FilterLayout: FC<FilterLayoutProps> = ({ onFilter }) => {
  const [regions, setRegions] = useState([]);
  useEffect(() => {
    axios.get<Assessment[]>(`${doeApiUrl}assessments?select=region`).then(({ data }) => {
      const selectItems = generateSelectItems(data);
      setRegions(selectItems);
    });
  }, []);

  return (
    <FormWrapper>
      <Form
        initialValues={{
          region: '',
          ASO: '',
        }}
        onSubmit={onFilter()}
      >
        <Row>
          <Col
            alignSelf="auto"
            display="block"
            elementType="div"
            flex="0 0 auto"
            md={4}
            order={0}
            xs={12}
          >
            <Select name="region" label="Region" options={regions} />
          </Col>
          <Col
            alignSelf="auto"
            display="block"
            elementType="div"
            flex="0 0 auto"
            md={4}
            order={0}
            xs={12}
          >
            <Input name="ASO" label="Asset Service Officer" />
          </Col>
        </Row>
        <Row>
          <Col
            alignSelf="auto"
            display="block"
            elementType="div"
            flex="0 0 auto"
            md={4}
            order={0}
            xs={12}
          >
            <Button inline color="primary" normal type="submit">
              Show Assessments
            </Button>
          </Col>
        </Row>
      </Form>
    </FormWrapper>
  );
};
